import { createContext, useContext } from 'react';
import { Sdk } from '@/types';
import { View3dConfigurationDto } from '@canvas-logic/clp-viewer3d';
import { IConfiguratorCatalogProductApiOptions, IConfiguratorUIDto } from '@canvas-logic/clp-api-types';
import { FetcherApi } from '@canvas-logic/clp-sdk';

export type ConfiguratorSettings = {
  sdk: Sdk;
  view3d: View3dConfigurationDto;
  configuratorUI: IConfiguratorUIDto;
  hideConfigurationControls: boolean;
  projectId: number;
  productId: number;
  // Always populated: `useConfiguratorRoute` coerces the query param with `Boolean(...)`,
  // and `Basic3dLayoutParams` requires it once the settings are spread into the layout.
  draft: boolean;
  params: IConfiguratorCatalogProductApiOptions;
  fetcher: FetcherApi;
  without3d?: boolean;
};
export const ConfiguratorContext = createContext<ConfiguratorSettings | null>(null);

export function useConfigurator() {
  return useContext(ConfiguratorContext);
}
